import installChemkitHostBridge from '../host/installChemkitHostBridge';
import { addonLifecycle, dashboard } from 'src/chemkit';

const { ADDON_READY_EVENT, ADDON_FAILED_EVENT, ADDON_READY_TIMEOUT_MS } = addonLifecycle;
const { DASHBOARD_CONFIG_WINDOW_KEY } = dashboard;

function waitForAddonReady(timeoutMs = ADDON_READY_TIMEOUT_MS) {
  return new Promise((resolve, reject) => {
    let settled = false;

    const cleanup = () => {
      window.removeEventListener(ADDON_READY_EVENT, onReady);
      window.removeEventListener(ADDON_FAILED_EVENT, onFailed);
      window.clearTimeout(timerId);
    };

    const settleResolve = () => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve();
    };

    const settleReject = (error) => {
      if (settled) return;
      settled = true;
      cleanup();
      reject(error);
    };

    const onReady = () => {
      settleResolve();
    };

    const onFailed = (event) => {
      const detail = event && event.detail && typeof event.detail === 'object' ? event.detail : {};
      const message = typeof detail.message === 'string'
        ? detail.message
        : 'Addon wake failed.';
      settleReject(new Error(message));
    };

    const timerId = window.setTimeout(() => {
      settleReject(new Error(`Timed out waiting for ${ADDON_READY_EVENT} (${timeoutMs}ms)`));
    }, timeoutMs);

    window.addEventListener(ADDON_READY_EVENT, onReady);
    window.addEventListener(ADDON_FAILED_EVENT, onFailed);
  });
}

export async function prepareChemkitBoot({ storeInstance, timeoutMs = ADDON_READY_TIMEOUT_MS }) {
  void storeInstance;
  window[DASHBOARD_CONFIG_WINDOW_KEY] = {
    ...(window[DASHBOARD_CONFIG_WINDOW_KEY] || {}),
    enabled: true,
  };

  const readyPromise = waitForAddonReady(timeoutMs);
  installChemkitHostBridge();
  await readyPromise;
}

export function renderChemkitBootFailure(domElement, error) {
  const message = error instanceof Error ? error.message : String(error);
  domElement.innerHTML = '';
  const node = document.createElement('div');
  node.setAttribute('data-chemkit-boot-failure', 'true');
  node.style.padding = '24px';
  node.style.fontFamily = 'sans-serif';
  node.style.color = '#8a1c1c';
  node.innerHTML = `Chemkit failed to initialize. Startup stopped.<br><small>${message}</small>`;
  domElement.appendChild(node);
}
